var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGovernorComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9998 12.6002V14.4002M6.2998 15.3002H11.6998M3.5998 12.6002H14.3998C15.3939 12.6002 16.1998 11.7943 16.1998 10.8002V4.5002C16.1998 3.50608 15.3939 2.7002 14.3998 2.7002H3.5998C2.60569 2.7002 1.7998 3.50608 1.7998 4.5002V10.8002C1.7998 11.7943 2.60569 12.6002 3.5998 12.6002Z",
    stroke: "#D7DFE9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGovernorComputer);
export default __webpack_public_path__ + "static/media/IconGovernorComputer.f5baa40d91550aa25465a61982056943.svg";
export { ForwardRef as ReactComponent };